import * as React from 'react';

import Zoom from '../../common/Zoom';
import PageNavigation from '../../common/PageNavigation';
import NavigationButtons from '../../common/NavigationButtons';
import ErrorMessage from '../../common/ErrorMessage';
import { IUserData } from 'src/infrastructure/interfaces';

export interface ISettingNav {
  docType: string;
  userData: IUserData;
  showPageNavButtons: boolean;
}

export default class SettingNav extends React.Component<ISettingNav> {

  render() {

    const { showPageNavButtons } = this.props;

    return (
      <div>
        <div className={`rightSidePane ${this.props.docType}`}>
          <NavigationButtons
            resultView={false}
            document={null}
            statesList={null}
            userData={this.props.userData}
          />
          <div className="rightSidePane-bottom">
            <ErrorMessage document={undefined}/>
            <Zoom handleZoom={undefined}/>
            <PageNavigation className="navigation-right-side"
              pages={undefined}
              spreads={undefined}
              isSpreadView={false}
              selectedPage={undefined}
              selectedSpread={undefined}
              selectPage={undefined}
              selectSpread={undefined}
              showNavButtons={showPageNavButtons}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/SidePanel/RightSidePanel/RightSidePanel.tsx